import {observer} from 'mobx-react-lite';
import React from 'react';
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";
import { Outlet } from 'react-router-dom';

const CreateRmaPage: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    
	return (
        <BasePageLayout title={getTranslation('CREATE_RMA', pageScope)} hasBack={true}>
            <Outlet />
        </BasePageLayout>
    )
});

export default CreateRmaPage;